import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Answer } from 'typings/filters'

type FilterValuesState = Record<string, Answer[]>

const initialState: FilterValuesState = {}

const filterValuesSlice = createSlice({
  name: 'filterValues',
  initialState,
  reducers: {
    setFilterValues(state, action: PayloadAction<{ variableId: string; values: Answer[] }>) {
      const { variableId, values } = action.payload
      state[variableId] = values
    },
  },
})

export const { setFilterValues } = filterValuesSlice.actions

export default filterValuesSlice.reducer
